/**
 * 解决hbuilder打包app之后点击手机返回键直接退出app的
 */
import { Toast } from 'vant';
// document.documentElement.addEventListener('touchstart', function (event) {
//   if (event.touches.length > 1) {
//     event.preventDefault();
//   }
// }, false);
// var lastTouchEnd = 0;
// document.documentElement.addEventListener('touchend', function (event) {
//   var now = Date.now();
//   if (now - lastTouchEnd <= 300) {
//     event.preventDefault();
//   }
//   lastTouchEnd = now;
// }, false);
document.addEventListener('plusready', function () {
  var webview = plus.webview.currentWebview()
  plus.navigator.setStatusBarBackground('#00000000');
  plus.navigator.setStatusBarStyle('dark');
  plus.key.addEventListener('backbutton', function () {
    webview.canBack(function (e) {
      if (e.canBack) {
        webview.back()
      } else {
        // 首页返回键处理
        // 1秒内，连续两次按返回键，则退出应用；
        var first = null
        plus.key.addEventListener(
          'backbutton',
          function () {
            // 首次按键，提示‘再按一次退出应用’
            console.log(sessionStorage)
            if (sessionStorage.getItem("quit") === "1") {
              if (!first) {
                first = new Date().getTime()
                // console.log('再按一次退出应用') // 此处可以用自定义提示
                Toast({
                  message: '再按一次退出应用',
                  position: 'bottom',
                });
                // this.$toast('提示文案');
                setTimeout(function () {
                  first = null
                }, 1000)
              } else {
                if (new Date().getTime() - first < 1500) {
                  plus.runtime.quit()
                }
              }
            }
          },
          false
        )
      }
    })
  })
})
